import React from 'react';
import PropTypes from 'prop-types';
import localisation from '../localisation.json';

export const getTranslation = (messageId, variables) => {
  const defaultValue = localisation[messageId] || messageId;
  if (!variables) {
    return defaultValue;
  }

  return Object.keys(variables).reduce(
    (result, key) =>
      result.replace(new RegExp(`\\$${key}`, 'g'), variables[key]),
    defaultValue
  );
};

const getContent = (str) => {
  if (/(<\w*)((\s\/>)|(.*<\/\w*>))/.test(str)) {
    return {
      dangerouslySetInnerHTML: {
        __html: str,
      },
    };
  }

  return { children: str };
};

const Text = ({ component, transformer, messageId, variables, ...rest }) => {
  const text = getTranslation(messageId, variables);
  const content = transformer ? transformer(text) : text;

  return React.createElement(component, {
    ...rest,
    ...getContent(content),
  });
};

Text.propTypes = {
  component: PropTypes.any,
  messageId: PropTypes.string,
  transformer: PropTypes.func,
  variables: PropTypes.object,
};

Text.defaultProps = {
  component: 'p',
};

export default Text;
